<div class="fm-google-maps"
  [class.fm-google-maps--hidden]="!showMap"
  #mapHostElement></div>